export default {"src":"/_next/static/media/0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6.dbe2fd42.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};